angular.module('bmsApp.dashboard', [
	'ui.router',
	'highcharts-ng'
])
	.config(['$stateProvider', '$urlRouterProvider', function config($stateProvider, $urlRouterProvider) {
			$stateProvider

				.state('main.dashboard', {
					url: '/dashboard',
					views: {
						'main@main': {
							templateUrl: 'ng/dashboard/templates/DashboardMain.html',
							controller: 'DashboardCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Dashboard'}
				})

				.state('main.dashboard.overview', {
					url: '^/dashboard/overview',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/DashboardOverview.html',
							controller: 'DashboardOverviewCtrl',
							controllerAs: 'Overview'
						}
					},
					ncyBreadcrumb: {label: 'Overview'}
				})

				.state('main.dashboard.tickets', {
					url: '^/dashboard/tickets',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/DashboardTicketIndex.html',
							controller: 'DashboardTicketIndexCtrl',
							controllerAs: 'Ticket'
						}
					},
					ncyBreadcrumb: {label: 'Tickets'}
				})

				.state('main.dashboard.training', {
					url: '^/dashboard/training',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/DashboardTraining.html',
						}
					},
					ncyBreadcrumb: {label: 'Training'}
				})

				.state('main.dashboard.ecommerce', {
					url: '^/dashboard/ecommerce',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/DashboardEcommerce.html',
							controller: 'DashboardEcommerceCtrl',
							controllerAs: 'Ecom'
						}
					},
					ncyBreadcrumb: {label: 'E-commerce'}
				})

				.state('main.dashboard.tickets.save', {
					url: '^/dashboard/ticket/{ticketId}',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/DashboardTicketSave.html',
							controller: 'DashboardTicketSaveCtrl',
							controllerAs: 'TicketSave'
						}
					},
					ncyBreadcrumb: {label: 'Tickets'}
				})

				.state('main.dashboard.marketing', {
					url: '^/dashboard/marketing',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/DashboardMarketing.html',
							controller: 'DashboardMarketingCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Marketing'}
				})

				.state('main.dashboard.businessPerformance', {
					url: '^/dashboard/business-performance',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/DashboardBusinessPerformance.html',
							controller: 'DashboardBusinessPerformanceCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Business Performance'}
				})

				.state('main.dashboard.leagueTable', {
					url: '^/dashboard/league-table',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/DashboardLeagueTable.html',
							controller: 'DashboardLeagueTableCtrl'
						}
					},
					ncyBreadcrumb: {label: 'League Table'}
				})

				.state('main.dashboard.today', {
					url: '^/dashboard/today',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/DashboardToday.html',
							controller: 'DashboardTodayCtrl',
							controllerAs: 'TodayCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Today'}
				})

				.state('main.dashboard.jobResolutionTasks', {
					url: '^/dashboard/job-resolution-tasks',
					views: {
						'content@main.dashboard': {
							templateUrl: 'ng/dashboard/templates/JobResolutionTasks.html',
							controller: 'JobResTaskCtrl',
							controllerAs: 'JobResTaskCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Job Resolution Tasks'}
				})

			;

		}]);
